import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

export const Settings = ({ closeModal }) => {
    const { openTimeModal } = useTimeModal();
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    const [content, setContent] = React.useState('settings');

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [userId, setUserId] = React.useState('');
    const [userRole, setUserRole] = React.useState('');
    const [isEmailOfFeedback, setIsEmailOfFeedback] = React.useState(false);
    const [isEmailOfLateCase, setIsEmailOfLateCase] = React.useState(false);
    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            axios.get('/api/user', {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setUserRole(response.data?.role);
                setUserId(response.data.id);
                setIsEmailOfFeedback(response.data.email_of_feedback);
                setIsEmailOfLateCase(response.data.email_of_late_case);

                setLoading(false);
            }).catch(err => {
                console.error('Ошибка получения данных '+err);
                setWarning('Ошибка системы при получении данных: '+err.message);
                setLoading(false);
            });
        } else {
            handleLogout();
        }
    }, []);

    const changeNotificationSetting = (nameSetting, valueSetting) => {
        axios.put(`/api/change-notification-setting`, {
            userId,
            nameSetting,
            valueSetting
        })
        .then(() => {
            openTimeModal('Настройка успешно изменена', 'success');
        })
        .catch(() => {
            openTimeModal('Не удалось изменить настройку. Попробуйте снова', 'error');
        })
    }

    const [confirmDelete, setConfirmDelete] = React.useState(false);

    const handleDeleteAccount = (userIdForDelete) => {
        const token = localStorage.getItem('token');
        axios.put(`/api/block-unblock-acc?userId=${userIdForDelete}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            handleLogout();
            setLoading(false);
        })
        .catch(err => {
            console.error('Ошибка системы при удалении учётной записи '+err);
            setWarning('Ошибка системы при удалении учётной записи: '+err.response.data || 'Ошибка сети.');
            setLoading(false);
        });
    }

    const handleDeleteButtonClick = () => {
        if (confirmDelete) {
            handleDeleteAccount(userId);
        } else {
            setConfirmDelete(true);
        }
    }

    const [currentMessage, setCurrentMessage] = React.useState('');
    const [infoMessage, setInfoMessage] = React.useState('');
    const [statusIM, setStatusIM] = React.useState('');

    React.useEffect(() => {
        if (reload) {
            axios.get('/api/info-message')
            .then(response => {
                if (response.data.length > 0) {
                    setCurrentMessage(response.data[0].message);
                } else {
                    setCurrentMessage('');
                }
            })
            .catch(error => {
                console.error('Ошибка при получении информационного сообщения:', error);
            })
            .finally(() => {
                setReload(false);
            });
        }
    }, [reload]);
    
    const addNewInfoMessage = (e) => {
        e.preventDefault();
        if (infoMessage !== '') {
            const token = localStorage.getItem('token');
            axios
                .post(`/api/add-new-info-message`, { infoMessage }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then(() => {
                    setReload(true);
                    setInfoMessage('');
                })
                .catch(err => {
                    setStatusIM('Ошибка при создании сообщения: ' + (err.response ? err.response.data : err.message));
                });
        } else {
            setStatusIM('Введите сообщение.');
        }
    };
    
    const deleteInfoMessage = () => {
        const token = localStorage.getItem('token');
        axios
            .delete(`/api/delete-all-info-messages`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(() => {
                setReload(true);
            })
            .catch(err => {
                setStatusIM('Ошибка при удалении сообщения: ' + (err.response ? err.response.data : err.message));
            });
    };


    const [versions, setVersions] = React.useState([]);
    React.useEffect(() => {
        if (content=='versions') {
            axios.get('/api/get-versions')
            .then(response => {
                setVersions(response.data);
            })
            .catch(error => {
                console.error('Ошибка при получении информационного сообщения:', error);
                setWarning(error.response?.data.message || error.message);
            })
            .finally(() => {
                setReload(false);
            });
        }
    }, [reload]);
    



    if (content == 'settings') {
        return (
            <div className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Настройки</h1>
                    <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    {loading ? 
                    (
                        <Loading />
                    ) 
                    : 
                    (
                        warning ? (
                        <>
                            <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{warning}</a>
                        </>
                        )
                        : 
                        (
                            <>
                            {userRole=="Администратор" ? (
                                <>
                                    <div className={styles.settingLine}>
                                        <a className={styles.settingLabel}>Пользователи</a>
                                        <Link to='/users' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
                                    </div>
                                    <div className={styles.settingLine}>
                                        <a className={styles.settingLabel}>Страница изменения категорий и этапов</a>
                                        <Link to='/types-categories-phases' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
                                    </div>
                                    <div className={styles.settingLine}>
                                        <a className={styles.settingLabel}>Страница просмотра обращений обратной связи</a>
                                        <Link to='/view-feedback' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
                                    </div>
                                    <div className={styles.settingLine}>
                                        <a className={styles.settingLabel}>Выгрузка данных</a>
                                        <Link to='/unloading' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
                                    </div>

                                    <div className={styles.settingLine} style={{cursor: 'pointer'}} onClick={() => {setContent('infoMessage')}}>
                                        <a className={styles.settingLabel}>Задать информационное сообщение для всех пользователей</a>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="angle-right-b"><path fill="#7d7d7d" d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"></path></svg>
                                    </div>

                                    <div className={styles.settingLine}>
                                        <a className={styles.settingLabel}>Журнал действий в системе</a>
                                        <Link to='/activity-log' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
                                    </div>

                                    <div className={styles.settingLine}>
                                        <a className={styles.settingLabel}>Тестирование системы</a>
                                        <Link to='/tstng' onClick={() => closeModal()} className='button' style={{marginLeft: '10px'}}>Перейти</Link>
                                    </div>
                                    
                                    <div className={styles.settingLine}>
                                        <a className={styles.settingLabel}>Присылать email-уведомления об обращениях в поддержку</a>
                                        <div className='checkboxWrapper'>
                                            <label className='switch' htmlFor='email_of_feedback'>
                                                <input type='checkbox' id='email_of_feedback' checked={isEmailOfFeedback} onChange={(e) => {setIsEmailOfFeedback(e.target.checked); changeNotificationSetting('email_of_feedback', !isEmailOfFeedback)}} />
                                                <div className='slider round'></div>
                                            </label>
                                        </div>
                                    </div>
                                </>
                                ) : (
                                <></>
                                )
                            }
                                <div className={styles.settingLine} style={{cursor: 'pointer'}} onClick={() => {setContent('elementsData')}}>
                                    <a className={styles.settingLabel}>Элементы управления данными</a>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="angle-right-b"><path fill="#7d7d7d" d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"></path></svg>
                                </div>
                                <div className={styles.settingLine}>
                                    <a className={styles.settingLabel}>Присылать email-уведомления о неисполнении дела в срок</a>
                                    <div className='checkboxWrapper'>
                                        <label className='switch' htmlFor='email_of_late_case'>
                                            <input type="checkbox"  id='email_of_late_case' checked={isEmailOfLateCase} onChange={(e) => {setIsEmailOfLateCase(e.target.checked); changeNotificationSetting('email_of_late_case', !isEmailOfLateCase)}} />
                                            <div className='slider round'></div>
                                        </label>
                                    </div>
                                </div>

                                <a className={styles.version}>Версия: 2.3 (11.06.2025)</a>
                            </>
                        )
                    )
                    }
                </div>
                </form>
            </div>
        )
    }

    if (content == 'elementsData') {
        return (
            <div className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        <svg style={{cursor: 'pointer', height: '30px', marginRight: '10px'}} onClick={() => {setContent('settings'); setConfirmDelete(false);}} viewBox="0 0 24 24">
                            <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
                        </svg>
                        Элементы управления данными
                    </h1>
                    <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    {loading ? 
                    (
                        <Loading />
                    ) 
                    : 
                    (warning ? (
                        <>
                            <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{warning}</a>
                        </>
                        )
                        : 
                        (
                            <>                             
                                <div className={styles.settingLine}>
                                    <a className={styles.settingLabel}>Изменить пароль</a>
                                    <Link to='/safety/change-password' type='button' className='button rounded' onClick={() => {closeModal()}}>Изменить</Link>
                                </div>
                                <div className={styles.settingLine}>
                                    <a className={styles.settingLabel}>Деактивировать учётную запись</a>
                                    <button type='button' className='button red rounded' style={{height: '40px'}} onClick={handleDeleteButtonClick}>
                                        {confirmDelete ? 'Подтвердить' : 'Деактивировать'}
                                    </button>
                                </div>
                                <a className={styles.settingDescription}>Обратите внимание, что деактивация учётной записи не приводит к полному уничтожению всех связанных с ней данных. Это необходимо для соблюдения требований законодательства и обеспечения работоспособности системы.<br />После деактивации данные учётной записи больше не будут использоваться для отправки уведомлений по электронной почте или прикрепления вас к юридическим делам.<br /><br />За более подробной информацией о том, как используются ваши данные, посетите страницу "Пользовательское соглашение и политика конфиденциальности"</a>
                                <div className={styles.settingLine}>
                                    <a className={styles.settingLabel}>Пользовательское соглашение и политика конфиденциальности</a>
                                    <Link to='/privacy-policy' onClick={() => closeModal()} className='button rounded' style={{marginLeft: '10px'}}>Перейти</Link>
                                </div>
                            </>
                        )
                    )
                    }
                </div>
                </form>
            </div>
        )
    }

    if (content == 'infoMessage') {
        return (
            <div className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        <svg style={{cursor: 'pointer', height: '30px', marginRight: '10px'}} onClick={() => {setContent('settings'); setConfirmDelete(false);}} viewBox="0 0 24 24">
                            <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
                        </svg>
                        Информационное сообщение
                    </h1>
                    <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    {loading ? 
                    (
                        <Loading />
                    ) 
                    : 
                    (userRole=='Администратор' ? 
                        ( currentMessage ? (
                            <>
                                <div className={styles.settingLine}>
                                    <a className={styles.settingLabel} style={{width: '100%'}}>Удалить информационное сообщение: "{currentMessage}"</a>
                                    <button type='button' className='button rounded red' onClick={() => {deleteInfoMessage()}}>Удалить</button>
                                </div>
                            </>
                            ) : (
                            <>
                                <a>Введите информационное сообщение</a>
                                <input type='text' value={infoMessage} onChange={(e) => setInfoMessage(e.target.value)} placeholder='Информационное сообщение' minLength='5' maxLength='500' required />
                                {statusIM && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{statusIM}</a>}
                                <button className='button maxWidth black' onClick={(e) => {addNewInfoMessage(e)}}>Задать сообщение</button>
                            </>
                            )
                        ) : (
                            <a>У вашей недостаточный доступ на просмотр содержимого.</a>
                        )
                    )
                    }
                </div>
                </form>
            </div>
        )
    }
}



export default Settings;